import React from 'react'
import { Select } from 'antd'
import { connect } from 'react-redux';
import {changeAccount} from '../../actions/account';
import ApiServce from '../../actions/apiService'

class AccountDropDown extends React.Component {

  state = {
    accounts: [],
    isLoading: true
  }
  
  async componentWillMount() {
    const data = await ApiServce.getAccounts();
    if (data) {
      this.setState({
        accounts: data,
        isLoading: false,
      });
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }
  
  changeAccount = (account) => {
    
    const {accounts} = this.state;
    const selectedAccount = accounts.find(x => x.pKey_TPM_Account_GUID === account);
    this.props.onChangeAccount(selectedAccount);
    
  }
  
  render() {
    const { account } = this.props;
    const { accounts, isLoading } = this.state;
    return (
      <Select style={{width: '100%'}} value={account} onChange={this.changeAccount}>
        <Select.Option value="all">All</Select.Option>
        {
          !isLoading && (accounts || []).map(item => (
            <Select.Option value={item.pKey_TPM_Account_GUID }>{item.accountNickname}</Select.Option>
          ))
        }
      </Select> )
  }
}

const mapStateToProps = (state) => ({
  account: state.account.selectedAccount
})

const mapDispatchToProps = (dispatch: Function) => ({
  onChangeAccount: (account) => {
    dispatch(changeAccount(account))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(AccountDropDown)



// WEBPACK FOOTER //
// ./src/components/layout-main/AccountDropDown.js